import { useParamsSearch } from '@anytag/shared-hooks';
import { EngagementProposalSearchSchemaType, TableModeType } from '../../schema-types';

export const useEngagementProposalSearch = () => {
  const paramsSearch = useParamsSearch<EngagementProposalSearchSchemaType>();

  const { filter, setFilter } = paramsSearch;

  const resetViewMode = () => {
    setFilter({ tableViewMode: TableModeType.VIEW });
  };

  return {
    ...paramsSearch,
    resetViewMode,
    isEditMode: filter.tableViewMode === TableModeType.EDIT
  };
};
